<template>
  <div class="page-header-wrapper">
    <h1>{{ $t("b2b:kyc.data_check.title") }}</h1>
    <p>{{ $t("b2b:kyc.data_check.subtitle") }}</p>
  </div>
  <Input
    v-model="kycData.lastName"
    :label="$t('b2b:kyc.data_check.last_name.label')"
  />
  <Input
    v-model="kycData.firstName"
    :label="$t('b2b:kyc.data_check.first_name.label')"
  />
  <!-- <Input
    v-model="kycData.mothersName"
    :label="$t('b2b:kyc.data_check.mothers_name.label')"
  /> -->
  <Input
    v-model="kycData.placeOfBirth"
    :label="$t('b2b:kyc.data_check.birth_place.label')"
  />
  <Input
    v-model="kycData.dateOfBirth"
    :label="$t('b2b:kyc.data_check.birth_date.label')"
    type="date"
  />
  <Input
    v-model="kycData.postCode"
    :label="$t('b2b:kyc.data_check.zip.label')"
  />
  <Input
    v-model="kycData.city"
    :label="$t('b2b:kyc.data_check.city.label')"
  />
  <Input
    v-model="kycData.street"
    :label="$t('b2b:kyc.data_check.street.label')"
  />
  <Input
    v-model="kycData.houseNumber"
    :label="$t('b2b:kyc.data_check.house_number.label')"
  />
</template>

<script setup>
import { useKycStore } from '~~/stores/kyc';
import { useProfileStore } from '~~/stores/profile';

const kycStore = useKycStore();
const profileStore = useProfileStore();

const route = useRoute();

const kycData = ref({});

function toTitleCase(text) {
  try {
    return text.toLowerCase()
      .split(' ')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ')
      .trim();
  } catch {
    return "";
  }
}

watch(
  kycData,
  (value) => {
    kycStore.customerData = value;
  },
  { immediate: true, deep: true }
)

watch(() => kycStore.kyc, () => {
  if (!kycStore.kyc) return;
  kycData.value.publicId = route.params.publicId || route.params.prescoreId;
  kycData.value.dateOfBirth = new Date(kycStore.kyc.birthDate || profileStore.dateOfBirth);
  kycData.value.firstName = toTitleCase(kycStore.kyc.firstName || profileStore.firstName);
  kycData.value.lastName = toTitleCase(kycStore.kyc.lastName || profileStore.lastName);
  kycData.value.postCode = toTitleCase(kycStore.kyc.permanentZip || profileStore.postCode);
  kycData.value.city = toTitleCase(kycStore.kyc.permanentCity || profileStore.city);
  kycData.value.placeOfBirth = toTitleCase(kycStore.kyc.birthPlace || profileStore.placeOfBirth);
  kycData.value.mothersName = "";
  const [street, houseNumber] = toTitleCase(kycStore.kyc.permanentStreet).replace(/^(\D*)(?<=\w)\s*(.*)/g, "$1~|~$2").split("~|~");
  kycData.value.street = street || profileStore.street;
  kycData.value.houseNumber = houseNumber || profileStore.houseNumber
}, { immediate: true })
</script>

<style>

</style>